import React from 'react'
import { FormattedMessage } from 'react-intl'
import AdditionalInfo from 'src/Components/shared/AdditionalInfo'
import { If, Text } from 'src/Components'
import Questions from 'src/Components/shared/Questions/QuestionsContainer'
import { QUESTIONS } from 'src/constants/messages'

const ShowInfo = ({ intl, withCurrentHomeData }) => {
  return (
    <>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.interest.info.headline'
          defaultMessage='Paying extra is an easy way to save'
        />
      </AdditionalInfo.Heading>
      <Text size='s' paragraph>
        <FormattedMessage
          id='Homeowner.interest.info.content1'
          defaultMessage="If you are able to pay a little extra to your principal each month, it&rsquo;ll cut down significantly on how much interest you pay in the long run. The best part is that there's no paperwork, fees or headaches."
        />
      </Text>
      <Text size='s' paragraph>
        <FormattedMessage
          id='Homeowner.interest.info.content2'
          defaultMessage='You just pay the extra amount you want onto your principal (not into your escrow).'
        />
      </Text>
      <If condition={withCurrentHomeData}>
        <Questions
          location='InterestCard'
          questionTopic={intl.formatMessage(QUESTIONS.interestCardTopic)}
          questions={[
            {
              question: intl.formatMessage(QUESTIONS.interestCardRefinance)
            },
            {
              question: intl.formatMessage(QUESTIONS.interestCardLargePayment)
            },
            {
              placeholder: intl.formatMessage(QUESTIONS.placeholder)
            }
          ]}
        />
      </If>
    </>
  )
}

export default ShowInfo
